

/// <reference path="TaxAnnotation.ts" />

// Generated class TaxModifierAnnotation_ManagedObject

class TaxModifierAnnotation_ManagedObject extends TaxAnnotation
{
}
